module.exports = __webpack_public_path__ + "img/showImg6.8319c7d6.png";